import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { Guide } from "@shared/modules/guides";
import { Card } from "../../../core/components/ui/card";
import { formatDateTime, toMs } from "../../../core/lib/format";
import { guidesApi } from "../lib/api";
import { GuideVisibilityBadge } from "./badges";

/** Widget d'accueil : les cinq derniers guides publiés. */
export function RecentGuidesCard() {
  const [guides, setGuides] = useState<Guide[] | null>(null);

  useEffect(() => {
    guidesApi
      .list()
      .then((list) =>
        setGuides(
          list
            .filter((g) => g.status === "published")
            .sort((a, b) => toMs(b.updatedAt) - toMs(a.updatedAt))
            .slice(0, 5),
        ),
      )
      .catch(() => setGuides([]));
  }, []);

  return (
    <Card title="Guides récents" subtitle="Procédures et tutoriels publiés." actions={<Link to="/guides">Tous les guides</Link>}>
      {guides === null ? <p className="muted">Chargement…</p> : null}
      {guides && guides.length === 0 ? <p className="muted">Aucun guide publié pour l'instant.</p> : null}
      {guides && guides.length > 0 ? (
        <ul className="guides-recent">
          {guides.map((g) => (
            <li key={g.id} className="guides-recent__item">
              <Link to={`/guides/${g.slug}`} className="guides-recent__link">
                <span className="guides-recent__title">{g.title}</span>
                <span className="guides-recent__date">{formatDateTime(g.updatedAt, { dateStyle: "medium" })}</span>
              </Link>
              <GuideVisibilityBadge visibility={g.visibility} />
            </li>
          ))}
        </ul>
      ) : null}
    </Card>
  );
}
